module.exports = __webpack_public_path__ + "static/media/gg_chevron-double-right.67e83105.svg";